import { render, staticRenderFns } from "./RipaDisability.vue?vue&type=template&id=6801a613"
import script from "./RipaDisability.vue?vue&type=script&lang=js"
export * from "./RipaDisability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports